export default __webpack_public_path__ + "static/media/mojecc.6ba92340.png";